import { useRef, useEffect, useState } from "react";
import styles from "./FormTextarea.module.css";

export default function FormTextarea({ label, defaultText = "", required, pattern, errorMsg, setFormValidity }) {
    const [value, setValue] = useState(defaultText);
    const inputRef = useRef();
    const id = label.replaceAll(" ", "_");

    // When defaultText changes, update value
    useEffect(() => {
        setValue(defaultText);
    }, [defaultText]);

    // Initialize formValidity state
    useEffect(() => {
        setFormValidity(formValidity => ({
            ...formValidity,
            [id]: false,
        }));
    }, [setFormValidity, id]);

    const handleValidation = function () {
        let valid = true;

        if (required && value === "") {
            inputRef.current.setCustomValidity("Textarea cannot be empty");
            inputRef.current.reportValidity();
            valid = false;
        } else if (!pattern.test(value) && value !== "") {
            inputRef.current.setCustomValidity(errorMsg);
            inputRef.current.reportValidity();
            valid = false;
        } else {
            inputRef.current.setCustomValidity("");
        }

        setFormValidity(formValidity => ({
            ...formValidity,
            [id]: valid,
        }));
    };

    return (
        <div className={styles.textareaInput}>
            <label htmlFor={id}>{required && <span>*</span>} {label}</label>
            <textarea
                name={label}
                id={id}
                ref={inputRef}
                value={value}
                onChange={e => {
                    setValue(e.target.value);
                    handleValidation();
                }}
                onBlur={handleValidation}
            />
        </div>
    );
}
